import { i18n } from "@bundles/UIAppBundle/i18n";
import phrases from "./config/Wines.i18n.json";
i18n.push(phrases);
// You can override additional messages here by using i18n.push();
